import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';
export default function UIBreakString(_ref) {
  let {
    children,
    className,
    hyphenate
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "className", "hyphenate"]);

  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    className: classNames('private-break-string', className, hyphenate ? 'private-break-string--hyphenate' : 'private-break-string--no-hyphenate'),
    children: children
  }));
}
UIBreakString.propTypes = {
  children: PropTypes.node.isRequired,
  hyphenate: PropTypes.bool
};
UIBreakString.defaultProps = {
  hyphenate: true
};
UIBreakString.displayName = 'UIBreakString';